import React, { useState, useMemo, useEffect } from 'react';

const Mascot = ({ type, message, onClick, emotion, isJumping }) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [type]);

  const config = useMemo(() => {
    const safeType = String(type || '');
    const isDolly = safeType.startsWith('dolly');

    const style = isDolly
      ? { name: 'dollybelle', borderColor: 'border-pink-500', textColor: 'text-pink-600', bgColor: 'bg-pink-200' }
      : { name: 'bribark', borderColor: 'border-blue-600', textColor: 'text-blue-600', bgColor: 'bg-blue-200' };

    let fileName = safeType;

    // Compatibilidad: formatos antiguos con underscore
    // bribark_backpack / dollybelle_backpack  -> bribarkmochila / dollybellemochila
    if (/_backpack$/.test(fileName)) {
      fileName = fileName.replace(/_backpack$/, 'mochila');
    }

    // (Opcional) si alguna vez usas "book"
    if (/_book$/.test(fileName)) {
      fileName = fileName.replace(/_book$/, 'libro');
    }

    // Elimina underscores restantes
    fileName = fileName.replace(/_/g, '');

    return {
      ...style,
      src: `/avatars/${fileName}.png`
    };
  }, [type]);

  return (
    <div
      className={`relative flex flex-col items-center animate-in slide-in-from-bottom-5 fade-in duration-300 cursor-pointer transition-transform
        ${isJumping ? 'animate-jump' : 'hover:scale-105'}
      `}
      onClick={onClick}
    >
      {message && (
        <div className="mb-3 bg-white px-4 py-2 rounded-2xl rounded-bl-none shadow-lg border border-slate-100 max-w-[200px] relative animate-bounce z-10">
          <p className="text-slate-700 font-bold text-xs leading-relaxed">{message}</p>
          <div className="absolute -bottom-1.5 left-4 w-3 h-3 bg-white border-b border-r border-slate-100 transform rotate-45"></div>
        </div>
      )}

      <div className="p-1 bg-white rounded-full shadow-xl relative z-0">
        {!imgError ? (
          <img
            src={config.src}
            alt={config.name}
            onError={() => {
              console.error("Error cargando avatar:", config.src);
              setImgError(true);
            }}
            className={`w-24 h-24 rounded-full object-cover border-4 ${config.borderColor}`}
          />
        ) : (
          <div className={`w-24 h-24 rounded-full border-4 ${config.borderColor} ${config.bgColor} flex flex-col items-center justify-center text-slate-500`}>
            <span className="text-xl">?</span>
            <span className="text-[8px] font-bold">Sin Imagen</span>
          </div>
        )}
      </div>

      <div className="mt-2 bg-white/90 backdrop-blur px-3 py-0.5 rounded-full border shadow-sm">
        <span className={`text-[10px] font-black uppercase tracking-widest ${config.textColor}`}>
          {config.name}
        </span>
      </div>
    </div>
  );
};

export default Mascot;
